<template>
  <div class="mb-8 content-container">
    <a-alert
      show-icon
      message="Non puoi più modificare queste informazioni perchè hai già scelto un'offerta"
      type="warning"
    >
      <template slot="description" v-if="order.ui_step > 5">
        Se vuoi puoi visualizzare i
        <a v-if="order.ui_step > 5" @click="cta">dettagli completi tuo ordine cliccando qui</a>
        oppure partire con un
        <a @click="resetOrder">nuovo ordine.</a>
      </template>

      <template v-else slot="description">
        Puoi completare il tuo ordine
        <a @click="cta">cliccando qui</a>
        oppure partire con un
        <a @click="resetOrder">nuovo ordine.</a>
      </template>
    </a-alert>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'readonly-banner',
  props: {
    msg: {
      type: String,
      default: ' Hai già scelto un offerta per questo ordine.'
    }
  },

  computed: {
    order() {
      return this.$store.state.order;
    }
  },

  methods: {
    async resetOrder() {
      await api.resetOrder();
      this.$store.commit('setOrder', null);
      this.$router.replace('/');
    },

    cta() {
      this.$store.commit('setActiveOrder', this.order);

      if (this.order.customer && this.order.customer.address) {
        return this.$router.push('/order');
      }

      this.$router.replace('/customer-full-info');
    }
  }
};
</script>

<style lang="scss">
@import '@/variables.scss';

.ant-alert a {
  text-decoration: underline;
  color: #ed8936;
}
</style>
